var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("MonthPickerDialog", {
        attrs: { viewModel: _vm.planningStartDateMonthPicker },
        on: {
          "update-date": function ($event) {
            _vm.planningStartDate = $event
          },
        },
      }),
      _vm._v(" "),
      _c("MonthPickerDialog", {
        attrs: { viewModel: _vm.planningEndDateMonthPicker },
        on: {
          "update-date": function ($event) {
            _vm.planningEndDate = $event
          },
        },
      }),
      _vm._v(" "),
      _c("MonthPickerDialog", {
        attrs: { viewModel: _vm.benefitsConfidenceDateMonthPicker },
        on: {
          "update-date": function ($event) {
            _vm.benefitsConfidenceDate = $event
          },
        },
      }),
      _vm._v(" "),
      _c("CorporateNavigation", { attrs: { ActivePage: "dashboard" } }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _vm.scenarioId
                    ? _c("h6", [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: `/#/enterprise-plan/portfolios/${_vm.workspaceId}/${_vm.strategyId}/${_vm.scenarioId}`,
                                expression:
                                  "`/#/enterprise-plan/portfolios/${workspaceId}/${strategyId}/${scenarioId}`",
                              },
                            ],
                            staticClass: "text-dark",
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-angle-double-left",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(" Back to plan\n                    "),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.scenarioId
                    ? _c("h6", [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: `/#/enterprise/planning/${_vm.workspaceId}/${_vm.strategyId}`,
                                expression:
                                  "`/#/enterprise/planning/${workspaceId}/${strategyId}`",
                              },
                            ],
                            staticClass: "text-dark",
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-angle-double-left",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(" Back to plans\n                    "),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v("Enterprise plan settings")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        staticStyle: { padding: "0.7em 2em" },
                        attrs: { type: "submit", form: "scenarioSettings" },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.scenarioId ? "Save changes" : "Create plan"
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "form",
                {
                  attrs: { id: "scenarioSettings" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.handleSavePortfolioScenarioSettings.apply(
                        null,
                        arguments
                      )
                    },
                  },
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Name:")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.rm.ScenarioName,
                          expression: "rm.ScenarioName",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", required: "", minlength: "2" },
                      domProps: { value: _vm.rm.ScenarioName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.rm,
                            "ScenarioName",
                            $event.target.value.trim()
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Description:")]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.rm.Description,
                          expression: "rm.Description",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control",
                      domProps: { value: _vm.rm.Description },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.rm,
                            "Description",
                            $event.target.value.trim()
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row" }, [
                    _c("div", { staticClass: "form-group col" }, [
                      _c("label", { attrs: { for: "denomination" } }, [
                        _vm._v("Currency denomination:"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.rm.Denomination,
                              expression: "rm.Denomination",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { id: "denomination" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.rm,
                                "Denomination",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "Unit" } }, [
                            _vm._v("Unit"),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "Thousand" } }, [
                            _vm._v("Thousand"),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "Million" } }, [
                            _vm._v("Million"),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row" }, [
                    _c("div", { staticClass: "form-group col" }, [
                      _c("label", [_vm._v("Planning from:")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group" }, [
                        _c("input", {
                          staticClass: "form-control pointer bg-white",
                          attrs: { type: "text", readonly: "" },
                          domProps: { value: _vm.planningStartDateLabel },
                          on: { click: _vm.showPlanningStartDateMonthPicker },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group-append" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: _vm.showPlanningStartDateMonthPicker,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-regular fa-calendar",
                                attrs: { "aria-hidden": "true" },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "error" }, [
                        _vm._v(_vm._s(_vm.rm.planningStartDateError)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group col" }, [
                      _c("label", [_vm._v("Planning to:")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group" }, [
                        _c("input", {
                          staticClass: "form-control pointer bg-white",
                          attrs: { type: "text", readonly: "" },
                          domProps: { value: _vm.planningEndDateLabel },
                          on: { click: _vm.showPlanningEndDateMonthPicker },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group-append" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button" },
                              on: { click: _vm.showPlanningEndDateMonthPicker },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-regular fa-calendar",
                                attrs: { "aria-hidden": "true" },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "error" }, [
                        _vm._v(_vm._s(_vm.rm.planningEndDateError)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row" }, [
                    _c("div", { staticClass: "form-group col" }, [
                      _c("label", [_vm._v("Risk adjusted benefits:")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.rm.ApplyBenefitsConfidenceFactor,
                              expression: "rm.ApplyBenefitsConfidenceFactor",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.rm,
                                "ApplyBenefitsConfidenceFactor",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { domProps: { value: true } }, [
                            _vm._v("Enabled"),
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: false } }, [
                            _vm._v("Disabled"),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group col" }, [
                      _c("label", [_vm._v("End of benefits confidence:")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group" }, [
                        _c("input", {
                          staticClass: "form-control pointer bg-white",
                          attrs: { type: "text", readonly: "" },
                          domProps: { value: _vm.benefitsConfidenceDateLabel },
                          on: {
                            click: _vm.showBenefitsConfidenceDateMonthPicker,
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group-append" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click:
                                  _vm.showBenefitsConfidenceDateMonthPicker,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-regular fa-calendar",
                                attrs: { "aria-hidden": "true" },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "my-4" }),
              _vm._v(" "),
              _c("h4"),
              _vm._v(" "),
              _c("table", { staticClass: "table table-bordered table-hover" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.rm.Portfolios, function (p) {
                    return _c("tr", { key: p.PortfolioId }, [
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "80px" },
                        },
                        [
                          _c(
                            "a",
                            {
                              class: p.IsConnected
                                ? "text-primary"
                                : "text-secondary",
                              on: {
                                click: function ($event) {
                                  p.IsConnected = !p.IsConnected
                                },
                              },
                            },
                            [
                              _c("i", {
                                class: p.IsConnected
                                  ? "fa-toggle-on fa fa-2xl fa-solid"
                                  : "fa-toggle-off fa fa-2xl fa-solid",
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(p.PortfolioName) +
                            "\n                    "
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", { staticClass: "table-secondary" }, [
        _c("th", { attrs: { colspan: "2" } }, [_vm._v("Connected Portfolios")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }